import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Redux
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/userDucks";
import { setDistributorDetails } from "../../redux/distributorDucks";
// Constants
import { pathHomePage, distributorMenu, eodyneWebsite, WEB_SERVICE_DASHBOARD_ROUTE } from "../../config/constants";
// Components
import {
  LayoutContainer,
  Sidebar,
  MenuSection,
  MenuLink,
  MenuButton,
  MenuExternalLink,
  MenuIcon,
  MainColumn,
  MainContent,
} from "./styles";
import LanguageSelector from "./sections/languageSelector";
import AccountDetails from "./sections/accountDetails";
import UseFetch from "../../config/useFetch";
// Assets
import { calendar, smile, logout as logoutIcon, globe } from "../../assets/icons";

const menuIcons = {
  budgetGenerator: calendar,
};

// Marco comun de las vistas del distribuidor: menu lateral, selector de idioma
// y el contenido de la vista.
const DistributorLayout = ({ children }) => {
  const [isAccountModalOpen, setIsAccountModalOpen] = useState(false);
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(({ user }) => user.isLoggedIn);

  // Fetching the distributor contact details
  //
  // Se cargan aqui y no en el modal porque el presupuesto tambien los necesita
  // para el pie del PDF.
  useEffect(() => {
    const getDetailsSignal = new AbortController();

    if (isLoggedIn) {
      UseFetch("get", `${WEB_SERVICE_DASHBOARD_ROUTE}/distributor/get-details`, getDetailsSignal)
        .then(({ data }) => {
          dispatch(setDistributorDetails(data));
        })
        .catch((error) => {
          console.log("Get distributor details: ", error);
        });
    }

    return () => {
      getDetailsSignal.abort();
    };
  }, [isLoggedIn, dispatch]);

  const handleLogout = () => {
    dispatch(logout());
    history.replace(`${pathHomePage}/`);
  };

  return (
    <LayoutContainer>
      <Sidebar>
        <MenuSection>
          {distributorMenu.map(({ key, path }) => (
            <MenuLink key={key} to={`${pathHomePage}${path}`} $isActive={pathname.startsWith(`${pathHomePage}${path}`)}>
              <MenuIcon src={menuIcons[key]} alt="" />
              {t(`menu.${key}`)}
            </MenuLink>
          ))}
        </MenuSection>

        <MenuSection>
          <MenuButton type="button" onClick={() => setIsAccountModalOpen(true)}>
            <MenuIcon src={smile} alt="" />
            {t("menu.accountDetails")}
          </MenuButton>
          <MenuButton type="button" onClick={handleLogout}>
            <MenuIcon src={logoutIcon} alt="" />
            {t("menu.logout")}
          </MenuButton>
          <MenuExternalLink href={eodyneWebsite} target="_blank" rel="noopener noreferrer">
            <MenuIcon src={globe} alt="" />
            {t("menu.website")}
          </MenuExternalLink>
        </MenuSection>
      </Sidebar>

      <MainColumn>
        <LanguageSelector />
        <MainContent>{children}</MainContent>
      </MainColumn>

      {isAccountModalOpen && <AccountDetails onClose={() => setIsAccountModalOpen(false)} />}
    </LayoutContainer>
  );
};

export default DistributorLayout;
